<div class="modal-wrapper">
  <div class="confirmation-modal">
    <div class="text-content">
      <h3 class="title" [innerHTML]="title"></h3>
      <p class="description" [innerHTML]="message"></p>
    </div>
    <div class="buttons">
      <button (click)="close(true)">{{ okButtonText }}</button>
      <button (click)="close(false)">
        <b>{{ cancelButtonText }}</b>
      </button>
    </div>
  </div>
</div>
